//angular imports
import { ChangeDetectionStrategy, Component, input } from "@angular/core";

//local imports
import { CloseDialogMessage, CommandModel, Messenger } from "@app/shared";
import { CategoryModel, RoomContentDetails } from "@app/catalog";

@Component({
  selector: "add-room-content-form",
  templateUrl: "./add-room-content-form.component.html",
  styleUrl: "./add-room-content-form.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AddRoomContentFormComponent {
  public details = RoomContentDetails.empty();
  public categories = input.required<CategoryModel[]>();

  public cancelCommand = new CommandModel({
    executeAction: () => {
      this.messenger.send(new CloseDialogMessage());
      return Promise.resolve();
    },
  });

  public submitCommand = new CommandModel({
    executeAction: () => this.save(),
    isValid: this.details.isValid,
  });

  constructor(private messenger: Messenger) {}

  private save = async () => {};
}
